import React from "react";
import Capture from  './images/flag.jpg';
export default function Header() {
  return (
    <header
      className=" text-dark d-flex justify-content-between p-lg-2   "
      id="header1">
      <div id="left">
        <ul className="list-unstyled d-flex justify-content-between gap-lg-3 pt-3 ">
          <li className="pointer text-light">
            <i className="fa-solid fa-phone mx-2 " />
            {/* {number}{" "} */}
            <a href="tel:+923298064264" className="text-light text-decoration-none">+923298064264</a>
          </li>
          <li className="pointer text-light">
            <i className="fa-solid fa-envelope mx-2" />
            <a href="mailto:saadmukhtar584@gmail.com" className="text-decoration-none text-light">
           saadmukhtar584@gmail.com
          </a>
          </li>
        </ul>
      </div>
      <div id="right">
        <ul className="list-unstyled d-flex justify-content-between gap-3 px-3 py-2">
          <li>
            {/* {" "} */}
            <select
              name=""
              id="btn-currency"
              className="my-auto text-light p-1 pointer">
              <option value="usd">USD</option>
              <option value="euro">euro</option>
              <option value="riyal">riyal</option>
            </select>
          </li>
          <li>
            <img
             src={Capture}
              id="flag"
              alt="flagee"
              className="my-auto object-fit-contain"
            />
          </li>
          <li>
            <select
              name=""
              id="btn-language"
              className="my-auto text-light p-1 pointer ">
              <option value="en">Eng</option>
              <option value="fr">French</option>
              <option value="Arabic">Arabic</option>
            </select>
          </li>
          <li>
            <ul
              className="list-unstyled d-flex fs-4 gap-2 my-auto "
              id="header1-icons">
              <li className="pointer text-light">
                <i className="fa-brands fa-facebook icon-disable " />
              </li>
              <li className="pointer text-light">
                <i className="fa-brands fa-linkedin icon-disable" />
              </li>
              <li className="pointer text-light">
                <i className="fa-brands fa-twitter icon-disable" />
              </li>
            </ul>
          </li>
          <li>
            <button
              className="mb-0 btn align-self-start btn-outline-light"
              id="Sign-In">
              Sign-In
            </button>
          </li>
        </ul>
      </div>
    </header>
    
  );
}
